<template>
  <el-dialog  :visible.sync="dialogVisible" top="10vh" width="800px" :close-on-click-modal="false" :show-close="false"	
    custom-class="video-player-dialog">
    <!-- 主容器：左侧播放区 + 右侧列表 -->
    <div v-if="dialogVisible" class="video-main-layout">
      <!-- 播放区域 -->
      <div class="video-player-wrapper">
        <div class="video-player">
          <!-- 阿里云视频 -->
          <div v-show="videoSource == 'AliVOD'&&videoList.length" id="video" style="width:99.8%;height:99.8%;position:relative;">
            <div class="pause_icon" :style="{ display: showOrNot }"></div>
            <div class="control_bar_modal"></div>
          </div>
            <!-- 腾讯视频 -->
          <video   v-show="videoSource != 'AliVOD'&&videoList.length" controls="controls" id="player-container-id" preload="auto" playsinline  webkit-playsinline></video>
        </div>
      </div>

      <!-- 视频列表 -->
      <div class="video-list-container" >
        <div style="display: flex; justify-content: space-between; align-items: center;margin-bottom: 16px;">
             <div>视频列表</div>
             <el-tag style="cursor: pointer;" @click="onClose" type="primary">退出</el-tag>
        </div>
     
        <ul class="video-list">
          <li v-for="(video, index) in videoList" :key="index" class="video-item"
            :class="{ active: selectVideoIndex === index }" @click="selectVideo(video,index)">
            {{ index + 1 }}
          </li>
        </ul>
      </div>
    </div>
  </el-dialog>
</template>

<script>
let Aliplayer = window.Aliplayer;
export default {
  name: 'VideoPlayerDialog',
  data() {
    return {
      selectVideoIndex: 0,
      dialogVisible: false,
      videoList: [], // 视频列表
      videoSource: '', // 视频源
      TCPlayer: null,
      player: null,
    };
  },
  methods: {
    disposePlayers() {
    // 销毁阿里云播放器
    if (this.player) {
      try {
        this.player.dispose();
      } catch (e) {
        console.warn('Aliplayer dispose error:', e);
      }
      this.player = null;
    }

    // 销毁腾讯云播放器
    if (this.TCPlayer) {
      try {
        this.TCPlayer.dispose(); 
      } catch (e) {
        console.warn('TCPlayer dispose error:', e);
      }
      this.TCPlayer = null;
    }

    // 清空容器（可选，确保干净）
    const tcContainer = document.getElementById('player-container-id');
    const aliContainer = document.getElementById('video');
    if (tcContainer) tcContainer.innerHTML = '';
    if (aliContainer) aliContainer.innerHTML = '';
  },
    getVideoList(obj) {
      let data = {
        ClassID: obj.ClassID,
        LessonID: obj.ID,
        PageSize: 100,
        PageIndex: 1 - 1,
      };
      this.$api
        .ListVideo(data)
        .then((res) => {
          this.videoList = res.VideoInfo
          console.log(this.videoList);
          //如果视频列表有视频，则默认第一个展示，然后设置 自动播放 关掉
          if (this.videoList.length > 0) {
            this.selectVideoIndex = 0;
            this.lookVideo(this.videoList[0])
          }
        })
        .catch((err) => {
        });
    },
    lookVideo(obj) {
      this.videoSource = obj.VideoSource
      console.log(obj.VideoSource);
      if (obj.VideoSource == 'TcVOD') {
        this.getTcVideoAccess(obj);
      } else {
        this.getAliVideoAccess(obj);
      }

    },
    getAliVideoAccess(obj) {
       const data = obj.VideoLocate ? {
          VideoID: obj.AliVideoID, VideoLocate: "Repo"
        } : {
          VideoID: obj.AliVideoID,
        }
        // GetPreviewAuth
        this.$api.GetPreviewAuth(data).then((res) => {
          console.log(res, 'rreess11')

          this.initAliVideo(res, obj.AliVideoID);
        })
          .catch((err) => {
          });
    },
    
    initAliVideo(res, videoId) {
      let vid = videoId;
      console.log(res, videoId);
      // 下面的定时回传播放时间的，如果player实例存在，则执行不通过那里，所以改用 this.videoId
      this.videoId = videoId;
      if (this.player != null) {
        this.player.replayByVidAndPlayAuth(videoId, res.PlayAuth.PlayAuth)
      } else {
        this.player = new Aliplayer(
          {
            id: 'video',
            width: '95%',
            height: '90%',
            videoHeight: 'calc(100% - 0.36rem - 20px - 34px )',
            autoplay: true,
            vid: vid,
            playauth: res.PlayAuth.PlayAuth,
            isLive: false,
            rePlay: false,
            playsinline: true,
            preload: true,
            controlBarVisibility: 'hover',
            useH5Prism: true,
          },
          (player) => {
            let videoDom = document.getElementsByTagName('video')[0];
            this.$utils.addEvent(videoDom, 'click', () => {
              if (this.player.getStatus() == 'playing') {
                this.player.pause();
              } else {
                this.player.play();
              }
            });
          },
        );
      }
    },
    getTcVideoAccess(obj) {
      const data = {
        VideoID: obj.AliVideoID,
        VideoLocate: obj.VideoLocate
      }
      this.$api.GetPreviewAuth(data).then((res) => {
        console.log(res, 'rreess')
        this.initTcVideo(res, obj.AliVideoID, obj.autoPlay);
      })
        .catch((err) => {
        });
    },
    initTcVideo(res, videoId, autoPlay) {
      console.log('执行了吗', this.tcInfo)
      const TCPlayer = window.TCPlayer;
      setTimeout(() => {
        let videoObj = {
          fileID: videoId, //exp:'5285890799710670616', // 请传入需要播放的视频filID 必须
          appID: res.PlayAuth.AppID, //exp:'1400329073', // 请传入点播账号的appID 必须
          psign: res.PlayAuth.PSign, // 参考 Key 防盗链说明
          licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1304435135_1/v_cube.license',
        }
        if (this.TCPlayer) {
          this.TCPlayer.loadVideoByID(videoObj);
        } else {
          console.log('执行了吗', videoObj)
          this.TCPlayer = TCPlayer('player-container-id', { // player-container-id 为播放器容器ID，必须与html中一致
            ...videoObj,
            //其他参数请在开发文档中查看
            autoplay: true,
            plugins: {
              ContinuePlay: {
                auto: true // 是否在播放时自动续播
              },
              ProgressMarker: true,
            }
          });
          this.TCPlayer.ready((res) => { console.log('ready', res) })
        }
      }, 100)
    },
    show(val) {
      console.log(val, 21);
     
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.getVideoList(val);
      })
    },
    selectVideo(video,index) {
      this.selectVideoIndex = index;
      this.lookVideo(video); // 播放视频
    },
    onClose() {
         this.dialogVisible = false;
        this.disposePlayers();
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
  #player-container-id {
  width: 100% !important;
  height: 100% !important;
}
.video-main-layout {
  display: flex;
  height: 450px;
  position: relative;
}

.video-player-wrapper {
  flex: 1;
  background-color: #000;
  border-radius: 4px;
  overflow: hidden;
  position: relative;

}

.video-player {
  width: 100%;
  height: 100%;
}


.empty-tip {
  color: #ccc;
  text-align: center;
  line-height: 600px;
  font-size: 16px;
}

.video-list-container {
  width: 132px;
  margin-left: 20px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
  max-height: 600px;
  overflow-y: auto;
}

.video-list-container h4 {
  margin-top: 0;
  font-size: 14px;
  color: #333;
}

.video-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.video-item {
  display: inline-block;
  line-height: 32px;
  text-align: center;
  width: 32px;
  height: 32px;
  border: 1px solid white;
  border-radius: 3px;
  cursor: pointer;
}

.video-item:hover {
  background-color: #e6f7ff;
}

.video-item:hover {
  background-color: #e6f7ff;
}

.video-item.active {
  background-color: #1890ff;
  color: white;
}
:deep .video-player-dialog .el-dialog__header {
 display: none;
}
/* 自定义 dialog 样式 */
:deep .video-player-dialog .el-dialog__body {
  padding: 16px!important;
}
</style>